export enum BillingPeriod {
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  YEARLY = "YEARLY",
  TWO_YEARS = "TWO_YEARS",
  THREE_YEARS = "THREE_YEARS",
  FOUR_YEARS = "FOUR_YEARS",
  FIVE_YEARS = "FIVE_YEARS",
}
